// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/analysis/v1/analysis.proto" (package "c1.api.analysis.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.analysis.v1.AnalysisServiceGetRequest
 */
export interface AnalysisServiceGetRequest {
    /**
     * @generated from protobuf field: string analysis_id = 1;
     */
    analysisId: string;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.AnalysisServiceGetResponse
 */
export interface AnalysisServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.analysis.v1.Analysis analysis = 1;
     */
    analysis?: Analysis;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.Analysis
 */
export interface Analysis {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 4;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string app_id = 5;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 6;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 7;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.analysis.v1.AnalysisState state = 8;
     */
    state: AnalysisState;
    /**
     * @generated from protobuf field: repeated c1.api.analysis.v1.Outcome outcomes = 9;
     */
    outcomes: Outcome[];
}
/**
 * @generated from protobuf message c1.api.analysis.v1.Outcome
 */
export interface Outcome {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 3;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.analysis.v1.OutcomeState state = 4;
     */
    state: OutcomeState;
    /**
     * @generated from protobuf field: google.protobuf.Any outcome = 5;
     */
    outcome?: Any;
    /**
     * @generated from protobuf field: string error = 6;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.Relevance
 */
export interface Relevance {
    /**
     * @generated from protobuf field: double relevance_score = 1;
     */
    relevanceScore: number;
    /**
     * @generated from protobuf field: int64 num_in_pop = 2;
     */
    numInPop: number;
    /**
     * @generated from protobuf field: int64 num_in_group = 3;
     */
    numInGroup: number;
    /**
     * @generated from protobuf field: int64 pop_with_access = 4;
     */
    popWithAccess: number;
    /**
     * @generated from protobuf field: int64 group_with_access = 5;
     */
    groupWithAccess: number;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.UserProp
 */
export interface UserProp {
    /**
     * @generated from protobuf field: string key = 1;
     */
    key: string;
    /**
     * @generated from protobuf field: string value = 2;
     */
    value: string;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.UserPropData
 */
export interface UserPropData {
    /**
     * @generated from protobuf field: c1.api.analysis.v1.UserProp user_prop = 2;
     */
    userProp?: UserProp;
    /**
     * @generated from protobuf field: c1.api.analysis.v1.Relevance relevance = 3;
     */
    relevance?: Relevance;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.UserPropOutcome
 */
export interface UserPropOutcome {
    /**
     * @generated from protobuf field: bool is_outcome = 1;
     */
    isOutcome: boolean;
    /**
     * @generated from protobuf field: c1.api.analysis.v1.UserPropData input = 2;
     */
    input?: UserPropData;
    /**
     * @generated from protobuf field: repeated c1.api.analysis.v1.UserPropData most_relevant = 3;
     */
    mostRelevant: UserPropData[];
}
/**
 * @generated from protobuf message c1.api.analysis.v1.GlobalOutcome
 */
export interface GlobalOutcome {
    /**
     * @generated from protobuf field: bool is_outcome = 1;
     */
    isOutcome: boolean;
    /**
     * @generated from protobuf field: int64 num_in_pop = 2;
     */
    numInPop: number;
    /**
     * @generated from protobuf field: int64 pop_with_access = 3;
     */
    popWithAccess: number;
    /**
     * @generated from protobuf field: int64 num_in_app = 4;
     */
    numInApp: number;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.AccountOutcome
 */
export interface AccountOutcome {
    /**
     * @generated from protobuf field: bool is_outcome = 1;
     */
    isOutcome: boolean;
    /**
     * @generated from protobuf field: int64 num_in_pop = 2;
     */
    numInPop: number;
    /**
     * @generated from protobuf field: int64 pop_with_access = 3;
     */
    popWithAccess: number;
    /**
     * @generated from protobuf field: int64 num_in_app = 4;
     */
    numInApp: number;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.ManagerData
 */
export interface ManagerData {
    /**
     * @generated from protobuf field: string manager_id = 1;
     */
    managerId: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: c1.api.analysis.v1.Relevance relevance = 3;
     */
    relevance?: Relevance;
}
/**
 * @generated from protobuf message c1.api.analysis.v1.ManagerOutcome
 */
export interface ManagerOutcome {
    /**
     * @generated from protobuf field: bool is_outcome = 1;
     */
    isOutcome: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.analysis.v1.ManagerData managers = 2;
     */
    managers: ManagerData[];
    /**
     * @generated from protobuf field: repeated c1.api.analysis.v1.ManagerData most_relevant = 3;
     */
    mostRelevant: ManagerData[];
}
/**
 * @generated from protobuf message c1.api.analysis.v1.AccessConflictOutcome
 */
export interface AccessConflictOutcome {
    /**
     * @generated from protobuf field: bool is_outcome = 1;
     */
    isOutcome: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.analysis.v1.AccessConflictData monitors = 2;
     */
    monitors: AccessConflictData[];
}
/**
 * @generated from protobuf message c1.api.analysis.v1.AccessConflictData
 */
export interface AccessConflictData {
    /**
     * @generated from protobuf field: string monitor_id = 1;
     */
    monitorId: string;
    /**
     * @generated from protobuf field: string monitor_display_name = 2;
     */
    monitorDisplayName: string;
}
/**
 * @generated from protobuf enum c1.api.analysis.v1.AnalysisState
 */
export enum AnalysisState {
    /**
     * @generated from protobuf enum value: ANALYSIS_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: ANALYSIS_STATE_CREATED = 1;
     */
    CREATED = 1,
    /**
     * @generated from protobuf enum value: ANALYSIS_STATE_STARTED = 2;
     */
    STARTED = 2,
    /**
     * @generated from protobuf enum value: ANALYSIS_STATE_DONE = 3;
     */
    DONE = 3,
    /**
     * @generated from protobuf enum value: ANALYSIS_STATE_ERROR = 4;
     */
    ERROR = 4
}
/**
 * @generated from protobuf enum c1.api.analysis.v1.OutcomeState
 */
export enum OutcomeState {
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_CREATED = 1;
     */
    CREATED = 1,
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_STARTED = 2;
     */
    STARTED = 2,
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_DONE = 3;
     */
    DONE = 3,
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_NA = 4;
     */
    NA = 4,
    /**
     * @generated from protobuf enum value: OUTCOME_STATE_ERROR = 5;
     */
    ERROR = 5
}
// @generated message type with reflection information, may provide speed optimized methods
class AnalysisServiceGetRequest$Type extends MessageType<AnalysisServiceGetRequest> {
    constructor() {
        super("c1.api.analysis.v1.AnalysisServiceGetRequest", [
            { no: 1, name: "analysis_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.AnalysisServiceGetRequest
 */
export const AnalysisServiceGetRequest = new AnalysisServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AnalysisServiceGetResponse$Type extends MessageType<AnalysisServiceGetResponse> {
    constructor() {
        super("c1.api.analysis.v1.AnalysisServiceGetResponse", [
            { no: 1, name: "analysis", kind: "message", T: () => Analysis }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.AnalysisServiceGetResponse
 */
export const AnalysisServiceGetResponse = new AnalysisServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Analysis$Type extends MessageType<Analysis> {
    constructor() {
        super("c1.api.analysis.v1.Analysis", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "state", kind: "enum", T: () => ["c1.api.analysis.v1.AnalysisState", AnalysisState, "ANALYSIS_STATE_"] },
            { no: 9, name: "outcomes", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Outcome }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.Analysis
 */
export const Analysis = new Analysis$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Outcome$Type extends MessageType<Outcome> {
    constructor() {
        super("c1.api.analysis.v1.Outcome", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "state", kind: "enum", T: () => ["c1.api.analysis.v1.OutcomeState", OutcomeState, "OUTCOME_STATE_"] },
            { no: 5, name: "outcome", kind: "message", T: () => Any },
            { no: 6, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.Outcome
 */
export const Outcome = new Outcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Relevance$Type extends MessageType<Relevance> {
    constructor() {
        super("c1.api.analysis.v1.Relevance", [
            { no: 1, name: "relevance_score", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "num_in_pop", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "num_in_group", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "pop_with_access", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 5, name: "group_with_access", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.Relevance
 */
export const Relevance = new Relevance$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserProp$Type extends MessageType<UserProp> {
    constructor() {
        super("c1.api.analysis.v1.UserProp", [
            { no: 1, name: "key", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.UserProp
 */
export const UserProp = new UserProp$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserPropData$Type extends MessageType<UserPropData> {
    constructor() {
        super("c1.api.analysis.v1.UserPropData", [
            { no: 2, name: "user_prop", kind: "message", T: () => UserProp },
            { no: 3, name: "relevance", kind: "message", T: () => Relevance }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.UserPropData
 */
export const UserPropData = new UserPropData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserPropOutcome$Type extends MessageType<UserPropOutcome> {
    constructor() {
        super("c1.api.analysis.v1.UserPropOutcome", [
            { no: 1, name: "is_outcome", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "input", kind: "message", T: () => UserPropData },
            { no: 3, name: "most_relevant", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserPropData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.UserPropOutcome
 */
export const UserPropOutcome = new UserPropOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GlobalOutcome$Type extends MessageType<GlobalOutcome> {
    constructor() {
        super("c1.api.analysis.v1.GlobalOutcome", [
            { no: 1, name: "is_outcome", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "num_in_pop", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "pop_with_access", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "num_in_app", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.GlobalOutcome
 */
export const GlobalOutcome = new GlobalOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccountOutcome$Type extends MessageType<AccountOutcome> {
    constructor() {
        super("c1.api.analysis.v1.AccountOutcome", [
            { no: 1, name: "is_outcome", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "num_in_pop", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "pop_with_access", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "num_in_app", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.AccountOutcome
 */
export const AccountOutcome = new AccountOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ManagerData$Type extends MessageType<ManagerData> {
    constructor() {
        super("c1.api.analysis.v1.ManagerData", [
            { no: 1, name: "manager_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "relevance", kind: "message", T: () => Relevance }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.ManagerData
 */
export const ManagerData = new ManagerData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ManagerOutcome$Type extends MessageType<ManagerOutcome> {
    constructor() {
        super("c1.api.analysis.v1.ManagerOutcome", [
            { no: 1, name: "is_outcome", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "managers", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ManagerData },
            { no: 3, name: "most_relevant", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ManagerData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.ManagerOutcome
 */
export const ManagerOutcome = new ManagerOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessConflictOutcome$Type extends MessageType<AccessConflictOutcome> {
    constructor() {
        super("c1.api.analysis.v1.AccessConflictOutcome", [
            { no: 1, name: "is_outcome", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "monitors", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AccessConflictData }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.AccessConflictOutcome
 */
export const AccessConflictOutcome = new AccessConflictOutcome$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AccessConflictData$Type extends MessageType<AccessConflictData> {
    constructor() {
        super("c1.api.analysis.v1.AccessConflictData", [
            { no: 1, name: "monitor_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "monitor_display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.analysis.v1.AccessConflictData
 */
export const AccessConflictData = new AccessConflictData$Type();
/**
 * @generated ServiceType for protobuf service c1.api.analysis.v1.AnalysisService
 */
export const AnalysisService = new ServiceType("c1.api.analysis.v1.AnalysisService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: AnalysisServiceGetRequest, O: AnalysisServiceGetResponse }
]);
